<!-- register.component.html -->
<div class="bg-gray-100 min-h-screen">
  <header class="bg-white shadow-sm border-b flex justify-center items-center">
    <div class="container mx-auto px-4 py-3 text-center">
      <h1 class="text-xl font-bold prompt-black">{{ currentLang === "TH" ? "ลงทะเบียน" : "Sign up"}}</h1>
    </div>
    <div class="flex items-center absolute right-3">
      <button class="w-8 h-8" (click)="changeLanguage('TH')">
        <p class="font-medium" [ngClass]="{ 
            'text-gray-500': currentLang !== 'TH',
            'text-green-500' : currentLang === 'TH'
          }">TH</p>
      </button>
      <button class="w-8 h-8" (click)="changeLanguage('EN')">
        <p class="font-medium" [ngClass]="{ 
            'text-gray-500': currentLang !== 'EN',
            'text-green-500' : currentLang === 'EN'
          }">EN</p>
      </button>
    </div>
  </header>
  <form>
    <main class="container mx-auto py-0 justify-center">
      <div class="p-5">
        <label class="block text-gray-700 text-sm mb-2 font-bold">
          <span class="text-red-500">*</span> {{ currentLang === "TH" ? "เบอร์โทร" : "Phone number" }}
        </label>
        <input
          class="bg-white shadow appearance-none border rounded w-full py-2 px-3 text-black leading-tight focus:outline-none focus:shadow-outline placeholder:text-slate-300"
          id="phoneNo" type="tel" (input)="filterNumberOnly($event); validateForm()" pattern="0[0-9]{9}" maxLength="10"
          placeholder="0912345678" (change)="handleCheckboxChange($event)" [(ngModel)]="phoneNo" name="phoneNo"
          #phoneNoField="ngModel" />
        <p class="text-red-500 text-xs mt-1" *ngIf="
            phoneNoField.invalid && (phoneNoField.dirty || phoneNoField.touched)
          ">
          {{ currentLang === "TH"
          ? "กรุณากรอกเบอร์โทรให้ถูกต้อง (ขึ้นต้นด้วย 0 และมี 10 หลัก)"
          : "Please enter a valid phone number starting with 0 and having 10 digits"
          }}
        </p>
        <label class="block text-gray-700 text-sm font-bold mb-2 mt-5">
          {{ currentLang === "TH" ? "รหัสคำเชิญ" : "Invite code" }}
        </label>
        <input
          class="bg-white shadow appearance-none border rounded w-full py-2 px-3 text-black leading-tight focus:outline-none focus:shadow-outline placeholder:text-slate-300"
          id="codeInvite" type="text" [(ngModel)]="codeInvite" name="codeInvite"
          placeholder="{{ currentLang === 'TH' ? 'รหัสคำเชิญ (ไม่จำเป็น)' : 'Invite code (optional)' }}" />
        <div class="flex items-start mt-5">
          <label class="flex items-center cursor-pointer relative">
            <input type="checkbox" name="agree" [(ngModel)]="agree" (change)="validateForm()"
              class="peer h-4 w-4 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-blue-600 checked:border-blue-600"
              id="check1" />
            <span
              class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor"
                stroke="currentColor" stroke-width="1">
                <path fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"></path>
              </svg>
            </span>
          </label>

          <!-- ข้อความ check box  -->
          <label for="checked-checkbox"
            class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300 block text-left text-[10px]">
            {{
            currentLang === "TH"
            ? "ฉันได้อ่านข้อตกลงที่เกี่ยวข้องแล้วยอมรับข้อกำหนดทั้งหมดที่มีอยู่ในนั้นและการแก้ไขเพิ่มเติมใดๆ ในภายหลัง
            โดยการคลิกปุ่ม"
            : "I have read and agree to the terms and conditions, as well as any future amendments, by clicking the
            button"
            }}
            <strong>
              {{ currentLang === "TH"
              ? "ลงทะเบียน"
              : "Sign up" }}
            </strong>
            {{ currentLang === "TH"
            ? "ด้านล่าง ฉันเข้าใจว่าฉันกำลังลงนามแบบดิจิทัลซึ่งมีผลบังคับใช้เช่นเดียวกับลายเซ็นด้วยลายมือ"
            : "below. I understand that I am signing a digital signature that is legally binding, equivalent to a
            handwritten signature."
            }}
            <br />
            <a (click)="openModal()" class="text-blue-600 hover:underline dark:text-blue-500">
              {{
              currentLang === "TH"
              ? "ที่จอดรถออนไลน์:เงื่อนไขการบริการ/นโยบายความเป็นส่วนตัว/นโยบายการคืนเงิน"
              : "Online Parking: Terms of Service / Privacy Policy / Refund Policy"
              }}
              <br />
              {{
              currentLang === "TH"
              ? "ผู้ให้บริการบุคคลที่สาม:เงื่อนไขการบริการ/นโยบายความเป็นส่วนตัว/ข้อกำหนดสาธารณะ "
              : "Third-party provider: Terms of Service / Privacy Policy / Terms of Use"
              }}</a>.
          </label>
        </div>
        <div class="flex justify-center items-center mt-8 w-full">
          <button type="submit" (click)="handleOnclick()" [disabled]="!isButton || error !== ''" [ngClass]="{
              'w-full py-2 px-4 font-bold text-white rounded-lg transition-all duration-300': true,
              'bg-green-500 hover:bg-green-600 cursor-pointer':
                isButton && error === '',
              'bg-gray-400 cursor-not-allowed': !isButton || error !== ''
            }">
            {{ currentLang === "TH" ? "ลงทะเบียน" : "Sign up" }}
          </button>
        </div>
      </div>
    </main>
  </form>

  <!-- ส่วนฟอร์มลงทะเบียนอยู่ตรงนี้ -->
</div>

<!-- ✅ Modal นโยบายความเป็นส่วนตัว -->
<div *ngIf="isModalOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 p-4">
  <div class="bg-white rounded-lg shadow-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto p-6 relative">
    <!-- ปุ่มปิด -->
    <button (click)="closeModal()" class="absolute top-3 right-3 text-gray-500 hover:text-black text-xl">
      &times;
    </button>

    <h2 class="text-lg font-semibold mb-4">{{ currentLang ==="TH" ? "นโยบายความเป็นส่วนตัว" : "Privacy Policy"}}</h2>
    <div class="text-sm text-gray-700 space-y-4">
      <p>
        <strong>{{ currentLang ==="TH" ? "1. ข้อมูลที่เราเก็บ:" : "1. Information we collect:"}}</strong>
        {{ currentLang === "TH"
        ? "ชื่อ-นามสกุล, ทะเบียนรถ,สี/รุ่นของรถ, วันเกิด, ที่อยู่, รูปโปรไฟล์จาก LINE, ข้อมูลติดต่อ เช่น
        เบอร์โทรและอีเมล"
        : "Name, vehicle registration number, vehicle color/model, date of birth, address, LINE profile picture, contact
        information, such as phone number and email"
        }}
      </p>

      <p>
        <strong>{{ currentLang ==="TH" ? "2. วัตถุประสงค์:" : "2. Purpose:"}}</strong>
        {{ currentLang === "TH"
        ? "ใช้เพื่อยืนยันตัวตนสมาชิก,ตรวจสอบการเปลี่ยนทะเบียนรถ, ติดต่อกลับ, และให้บริการตามระบบ"
        : "Used to verify membership, check vehicle registration changes, contact, and provide services"
        }}
      </p>

      <p>
        <strong>{{ currentLang ==="TH" ? "3. ความปลอดภัย:" : "3. Security:"}}</strong>
        {{ currentLang === "TH"
        ? "ข้อมูลจะถูกเก็บไว้อย่างปลอดภัยไม่เปิดเผยต่อบุคคลภายนอก เว้นแต่เป็นไปตามกฎหมาย"
        : "Information will be kept secure and not disclosed to third parties, except as required by law"
        }}
      </p>

      <p>
        <strong>{{ currentLang ==="TH" ? "4. ระยะเวลาการเก็บ:" : "4. Retention period:"}}</strong>
        {{ currentLang === "TH"
        ?"จนกว่าจะยกเลิกการเป็นสมาชิกหรือมีคำร้องขอลบข้อมูล"
        : "Until you stop being a member or make a request to delete data"
        }}
      </p>

      <p>
        <strong>{{ currentLang ==="TH" ? "5. สิทธิของผู้ใช้:" : "5. User rights:"}}</strong>
        {{ currentLang === "TH"
        ? "ผู้ใช้สามารถขอดู แก้ไขหรือลบข้อมูลส่วนบุคคลของตนได้ตลอดเวลา"
        : "Users can view, edit, or delete their personal information at any time"
        }}
      </p>

      <p>
        <strong>{{ currentLang ==="TH" ? "6. ข้อมูลการชำระเงิน:" : "6. Payment data:"}}</strong>
        {{ currentLang === "TH"
        ? "เว็บไซต์ใช้ระบบชำระเงินภายนอก เช่น Omise/2C2P โดยไม่เก็บข้อมูลบัตรเครดิต ข้อมูลที่จำเป็น เช่น ชื่อหรืออีเมล
        อาจถูกส่งต่อให้ผู้ให้บริการดังกล่าวผู้ใช้สามารถอ่านนโยบายความเป็นส่วนตัวของผู้ให้บริการได้จากเว็บไซต์ของผู้ให้บริการนั้น"
        : "The website uses external payment systems such as Omise/2C2P without storing credit card information.
        Required information such as name or email may be forwarded to such service providers. Users can read the
        service providers' privacy policies on their websites."
        }}
      </p>

      <p>
        <strong>{{ currentLang ==="TH" ? "7. การเก็บข้อมูลการใช้งาน:" : "7. Data collection:"}}</strong>
        {{
        currentLang === "TH"
        ? "เว็บไซต์จะเก็บประวัติการใช้งานของผู้ใช้ เช่น รายการเข้า-ออกตัวอาคารโดยใช้ยานพาหนะ, เวลาการเข้า-จอด,
        จำนวนครั้ง,ประวัติการชำระค่าจอดรถ รวมถึงข้อมูลการทำธุรกรรมต่าง ๆ
        เพื่อวัตถุประสงค์ในการบริหารจัดการระบบให้ปลอดภัย โปร่งใสและตรวจสอบย้อนหลังได้เมื่อจำเป็น"
        : "The website will keep a history of user activity, such as vehicle entry and exit records, parking times,
        number of times, parking payment history, and other transaction data for the purpose of managing the system to
        ensure security, transparency, and traceability when necessary."
        }}
      </p>

      <p>
        {{ currentLang === "TH"
        ? "โดยการกดยินยอมถือว่าผู้ใช้รับทราบและตกลงให้เว็บไซต์จัดเก็บและใช้ข้อมูลตามที่ระบุในนโยบายฉบับนี้"
        : "By clicking 'Agree', you acknowledge and agree that the website will collect and use the data as specified in
        this policy"
        }}
      </p>
    </div>
  </div>
</div>